import {
  ASSETS_API,
  ASSETS_API_PREFIX,
  HOST_API,
} from "../../../config-global";
import { Grid, Card, CircularProgress } from "@mui/material";
import FormProvider from "../../../components/minimal/hook-form";
import useApiServices from "api/useApiServices";
import QuestionTable from "./question-table/question-list-view";
import StepForm from "./step-form";
import { useForm } from "react-hook-form";
import LoadingButton from "@mui/lab/LoadingButton";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

interface StepFormUpdateProps {}

const StepFormUpdate: React.FC<StepFormUpdateProps> = () => {
  const { useGetListApi } = useApiServices();
  const { id: stepId } = useParams();
  const { usePatchApi } = useApiServices();
  const [isLoadingSteps, setIsLoadingSteps] = useState(true);
  const navigate = useNavigate();

  const methods = useForm({
    // resolver: formSchema && yupResolver(formSchema),
    defaultValues: {
      title: "",
      titleAr: "",
      stepAward: 6,
      coverImage: undefined,
    },
  });

  const {
    setValue,
    handleSubmit,
    reset,
    control,
    formState: { isSubmitting },
  } = methods;

  useGetListApi<any>({
    url: `${HOST_API}/api/admin/award-steps/${stepId}`,
    onSuccess(data) {
      console.log(data);
      const translationAr = data.translations.find(
        (translation: any) => translation.locale === "ar"
      );
      const translationEn = data.translations.find(
        (translation: any) => translation.locale === "en"
      );
      reset({
        ...data,
        title: translationEn?.title,
        titleAr: translationAr?.title,
        stepAward: data?.stepAward?.id,
        coverImage: ASSETS_API + ASSETS_API_PREFIX + data?.coverImageUrl,
      });
      setIsLoadingSteps(false);
    },
  });

  const { mutate: updateStep } = usePatchApi({
    url: "/api/admin/award-steps",
    id: String(stepId),
    onSuccess(data) {
      navigate(-1);
    },
  });

  const onSubmit = (data: any) => {
    const formData = new FormData();
    formData.append("translations[0][locale]", "en");
    formData.append("translations[0][title]", data.title);
    formData.append("translations[1][locale]", "ar");
    formData.append("translations[1][title]", data.titleAr);
    if (!data?.id) formData.append("stepAward", data.stepAward);
    formData.append("published", data.published);
    if (!data?.id || data.coverImage) {
      formData.append("coverImage", data.coverImage);
    }
    updateStep(formData);
  };

  return (
    <>
      {isLoadingSteps ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "70vh",
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <>
          <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
            <Card sx={{ p: 3, minHeight: "26rem" }}>
              <Grid container spacing={2}>
                <StepForm setValue={setValue} currentItem={stepId} />
              </Grid>

              <LoadingButton
                type="submit"
                variant="contained"
                loading={isSubmitting}
              >
                Update Step
              </LoadingButton>
            </Card>
          </FormProvider>
          <QuestionTable id={Number(stepId)} />
        </>
      )}
    </>
  );
};

export default StepFormUpdate;
